<template>
  <div class="container-fluid">
    <component v-bind:is="componentName"></component>
  </div>
</template>

<script>
export default {
  components: {
    login: () => import('../Login'),
    pagenotfound: () => import('../PageNotFound'),
  },
  computed: {
    componentName() {
      return this.$route.name.toLowerCase()
    },
  },
}
</script>
